// MoreDropDown.jsx
import React, { useState, useRef, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Classes from './RecordTable.module.css';
import { ThreeDotsIcon } from '../../../../../../utils/Icons';
import DeleteConfirmPopup from '../../../../../GlobalComponents/DeleteConfirmPopup/DeleteConfirmPopup';
import backend from '../../../../../../api';

export default function MoreDropDown({ userId, user, onDeleted }) {
  const [dropDown, setDropDown] = useState(false);
  const [openConfirmPopup, setOpenConfirmPopup] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const dropdownRef = useRef(null);
  const navigateTo = useNavigate();

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropDown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // ✅ fixed syntax + full flow
  const handleDelete = async () => {
    if (!user?._id) return;
    try {
      setIsDeleting(true);
      // adjust URL to match your backend route
      await backend.delete(`/api/user/${user._id}`);

      setOpenConfirmPopup(false);

      // notify parent to refresh/remove row
      if (typeof onDeleted === 'function') {
        onDeleted(user._id);
      } else {
        // alert('User deleted');
        window.location.reload()
      }
    } catch (err) {
      console.error('Delete failed:', err);
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        'Failed to delete user';
      alert(msg);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleCloseConfirmPopup = () => setOpenConfirmPopup(false);
  const handleOpenConfirmPopup = () => setOpenConfirmPopup(true);

  // Called by the popup's "Delete" button
  const handleConfirmSubmit = () => {
    // only delete after confirmation
    handleDelete();
  };

  return (
    <>
      <div className={Classes.dropDown} ref={dropdownRef}>
        <div
          className="flexAlign10 pointer mr10"
          onClick={() => setDropDown(!dropDown)}
        >
          <div className={Classes.dropdownIcon}>
            <ThreeDotsIcon height="15px" />
          </div>
        </div>

        <AnimatePresence>
          {dropDown && (
            <motion.div
              initial={{ opacity: 0, y: -5 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -5 }}
              transition={{ duration: 0.15 }}
              className={Classes.dropDownBody}
              style={{ top: '13px', right: '30px' }}
            >
              <div className={Classes.dropDownBodyInner}>
                <div
                  className={Classes.dropDownElem}
                  style={{ padding: '5px 10px' }}
                  onClick={() => {
                    navigateTo(`/client-detail/details/${userId}`);
                    setDropDown(false);
                  }}
                >
                  <h5>View Client</h5>
                </div>

                <div className={Classes.dropDownLine}></div>

                <div
                  className={Classes.dropDownElem}
                  style={{ padding: '5px 10px' }}
                  onClick={() => {
                    navigateTo(`/edit-client/${userId}`);
                    setDropDown(false);
                  }}
                >
                  <h5>Edit Client</h5>
                </div>

                <div className={Classes.dropDownLine}></div>

                <div
                  className={Classes.dropDownElem}
                  style={{ padding: '5px 10px' }}
                  onClick={() => {
                    navigateTo(`/messages?userId=${userId}`);
                    setDropDown(false);
                  }}
                >
                  <h5>Message Client</h5>
                </div>

                <div className={Classes.dropDownLine}></div>

                <div
                  className={Classes.dropDownElem}
                  style={{ padding: '5px 10px', color: 'red' }}
                  onClick={() => {
                    handleOpenConfirmPopup();
                    setDropDown(false);
                  }}
                >
                  <h5>Delete</h5>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
        <input type="hidden" aria-label="Without label" readOnly />
      </div>

      <AnimatePresence>
        {openConfirmPopup && (
          <DeleteConfirmPopup
            handleClose={handleCloseConfirmPopup}
            handleSubmit={handleConfirmSubmit}
            loading={isDeleting} // ⬅ pass loading to disable button & show "Deleting..."
          />
        )}
      </AnimatePresence>
    </>
  );
}
